export const MONOBANK_SETTINGS = {
  IMPORT_CONFIG: 'ui:monobank_import_config',
  API_TOKEN: 'secure:monobank_api_token',
  ACCOUNT_MAPPING: 'config:monobank_account_mapping',
  IMPORT_ENABLED: 'ff:monobank_import_enabled',
} as const;
